// 관리자 로그인 토큰 (koreavsa-be POST /admin/login 발급, 12시간 유효)
// 탭을 닫으면 사라지도록 sessionStorage 에 둔다.
const TOKEN_KEY = 'tournament-admin-token';

export const ADMIN_AUTH_EXPIRED_EVENT = 'tournament-admin-auth-expired';

function readTokenPayload(token) {
  try {
    const payload = token.split('.')[0].replace(/-/g, '+').replace(/_/g, '/');
    const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
    const [, role, exp] = atob(padded).split(':');
    return { role, exp: Number(exp) };
  } catch {
    return null;
  }
}

export function getAdminToken() {
  try {
    return sessionStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function isAdminAuthenticated() {
  const token = getAdminToken();
  if (!token) return false;
  const payload = readTokenPayload(token);
  return payload?.role === 'admin' && payload.exp * 1000 > Date.now();
}

export function isAdminToken(token) {
  return readTokenPayload(token)?.role === 'admin';
}

export function setAdminToken(token) {
  try {
    sessionStorage.setItem(TOKEN_KEY, token);
  } catch {
    // ignore storage errors
  }
}

export function clearAdminToken() {
  try {
    sessionStorage.removeItem(TOKEN_KEY);
  } catch {
    // ignore storage errors
  }
}
